var React = require('react');

function IconCreditCard (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M407 125H89C73.536 125 61 137.536 61 153V344C61 359.464 73.536 372 89 372H407C422.464 372 435 359.464 435 344V153C435 137.536 422.464 125 407 125ZM89 93C55.8629 93 29 119.863 29 153V344C29 377.137 55.8629 404 89 404H407C440.137 404 467 377.137 467 344V153C467 119.863 440.137 93 407 93H89Z","fill":"black","key":0}),React.createElement("path",{"d":"M56 188H440V220H56V188Z","fill":"black","key":1}),React.createElement("path",{"d":"M270 298C270 289.163 277.163 282 286 282H372C380.837 282 388 289.163 388 298C388 306.837 380.837 314 372 314H286C277.163 314 270 306.837 270 298Z","fill":"black","key":2})]);
}

IconCreditCard.defaultProps = {"width":"496","height":"496","viewBox":"0 0 496 496","fill":"none"};

module.exports = IconCreditCard;

IconCreditCard.default = IconCreditCard;
